import { ObservablePersistLocalStorageBase } from "@legendapp/state/persist-plugins/local-storage";
import { safeLocalStorage } from "./safe-storage";

/**
 * Плагин персиста legend-state поверх безопасного хранилища.
 *
 * Штатный ObservablePersistLocalStorage в конструкторе пишет
 * `typeof localStorage !== "undefined" ? localStorage : undefined`, а сама эта проверка дёргает
 * геттер и падает там, где браузер запретил данные сайта. Базовый класс принимает хранилище
 * параметром — отдаём ему обёртку, которая в таком случае молча уходит в память.
 */
export class ObservablePersistSafeLocalStorage extends ObservablePersistLocalStorageBase {
  constructor() {
    // Базовый класс типизирован полным Storage, но пользуется только get/set/removeItem.
    super(safeLocalStorage as unknown as Storage);
  }
}
